import { NivelAlgoritmoEnum, TipoAlgoritmoEnum } from "../../../../../enums";

type Props = {
  nivel: number;
  tipoAlgoritmo: number;
};

export function MontarExpressao({ nivel, tipoAlgoritmo }: Props) {
  let montagem: string[] = [];
  let listaCondicionais = [">", "<"];
  switch (tipoAlgoritmo) {
    case TipoAlgoritmoEnum.CALCULOS:
      switch (nivel) {
        case NivelAlgoritmoEnum.FACIL:
          let listaValores = ["numero1", "numero2", "valor"];
          let listaSimbolos = ["+", "-"];
          listaValores = listaValores.sort(() => Math.random() * 2 - 1);
          listaSimbolos = listaSimbolos.sort(() => Math.random() * 2 - 1);
          montagem.push(
            `${listaValores[0]} ${listaSimbolos[0]} ${listaValores[1]} ${listaSimbolos[1]} ${listaValores[2]}`
          );
          return montagem;
        case NivelAlgoritmoEnum.MEDIO:
          let varMedio = ["numero1", "numero2", "numero3", "valor"];
          let operMedio = ["+", "-"];
          varMedio = varMedio.sort(() => Math.random() * 2 - 1);
          operMedio = operMedio.sort(() => Math.random() * 2 - 1);
          montagem.push(
            `${varMedio[0]} ${operMedio[0]} ${varMedio[1]} ${operMedio[1]} ${varMedio[2]} ${operMedio[0]} ${varMedio[3]}`
          );
          return montagem;
        default:
          let varDificil = [
            "numero1",
            "numero2",
            "numero3",
            "numero4",
            "valor",
          ];
          let operDificil = ["+", "-", "*"];
          varDificil = varDificil.sort(() => Math.random() * 2 - 1);
          operDificil = operDificil.sort(() => Math.random() * 2 - 1);
          montagem.push(
            `${varDificil[0]} ${operDificil[0]} ${varDificil[1]} ${operDificil[1]} ${varDificil[2]} ${operDificil[2]} ${varDificil[3]} ${operDificil[0]} ${varDificil[4]}`
          );
          return montagem;
      }
    case TipoAlgoritmoEnum.CONDICIONAIS:
      switch (nivel) {
        case NivelAlgoritmoEnum.FACIL:
          let listaValores = ["numero1", "numero2", "valor"];
          let listaSimbolos = ["+", "-"];
          listaValores = listaValores.sort(() => Math.random() * 2 - 1);
          listaSimbolos = listaSimbolos.sort(() => Math.random() * 2 - 1);
          listaCondicionais = listaCondicionais.sort(
            () => Math.random() * 2 - 1
          );
          montagem.push(
            `${listaValores[0]} ${listaCondicionais[0]} ${listaValores[1]}`
          );
          montagem.push(
            `${listaValores[2]} ${listaSimbolos[1]} ${listaValores[1]} ${listaSimbolos[0]} ${listaValores[0]}`
          );
          montagem.push(
            `${listaValores[1]} ${listaSimbolos[0]} ${listaValores[0]} ${listaSimbolos[1]} ${listaValores[2]}`
          );
          return montagem;
        case NivelAlgoritmoEnum.MEDIO:
          let valoresMed = ["numero1", "numero2", "numero3", "valor"];
          let simbolosMed = ["+", "-"];
          valoresMed = valoresMed.sort(() => Math.random() * 2 - 1);
          simbolosMed = simbolosMed.sort(() => Math.random() * 2 - 1);
          listaCondicionais = listaCondicionais.sort(
            () => Math.random() * 2 - 1
          );
          montagem.push(
            `${valoresMed[0]} ${listaCondicionais[0]} ${valoresMed[1]}`
          );
          montagem.push(
            `${valoresMed[3]} ${simbolosMed[0]} ${valoresMed[2]} ${simbolosMed[0]} ${valoresMed[1]} ${simbolosMed[0]} ${valoresMed[0]}`
          );
          montagem.push(
            `${valoresMed[1]} ${simbolosMed[0]} ${valoresMed[0]} ${simbolosMed[0]} ${valoresMed[3]} ${simbolosMed[1]} ${valoresMed[2]}`
          );
          return montagem;
        default:
          let listaValoresDif = [
            "numero1",
            "numero2",
            "numero3",
            "numero4",
            "valor",
          ];
          let listaSimbolosDif = ["+", "-", "*"];
          listaValoresDif = listaValoresDif.sort(() => Math.random() * 2 - 1);
          listaSimbolosDif = listaSimbolosDif.sort(() => Math.random() * 2 - 1);
          listaCondicionais = listaCondicionais.sort(
            () => Math.random() * 2 - 1
          );
          montagem.push(
            `${listaValoresDif[0]} ${listaCondicionais[0]} ${listaValoresDif[1]}`
          );
          montagem.push(
            `${listaValoresDif[3]} ${listaSimbolosDif[0]} ${listaValoresDif[2]} ${listaSimbolosDif[1]} ${listaValoresDif[1]} ${listaSimbolosDif[2]} ${listaValoresDif[0]} ${listaSimbolosDif[0]} ${listaValoresDif[4]}`
          );
          montagem.push(
            `${listaValoresDif[1]} ${listaSimbolosDif[1]} ${listaValoresDif[0]} ${listaSimbolosDif[0]} ${listaValoresDif[3]} ${listaSimbolosDif[1]} ${listaValoresDif[2]} ${listaSimbolosDif[2]} ${listaValoresDif[4]}`
          );
          return montagem;
      }
    default:
      switch (nivel) {
        case NivelAlgoritmoEnum.FACIL:
          let listaVariaveis = ["numero1", "numero2"];
          let listaValores = ["valor"];
          let listaSimbolos = ["+"];
          listaVariaveis = listaVariaveis.sort(() => Math.random() * 2 - 1);
          listaValores = listaValores.sort(() => Math.random() * 2 - 1);
          listaCondicionais = listaCondicionais.sort(
            () => Math.random() * 2 - 1
          );
          montagem.push(
            `${listaVariaveis[0]} ${listaCondicionais[0]} ${listaVariaveis[1]}`
          );
          montagem.push(
            `${listaVariaveis[0]} ${listaSimbolos[0]} ${listaVariaveis[1]}`
          );
          montagem.push(`${listaValores[0]}`);
          return montagem;
        case NivelAlgoritmoEnum.MEDIO:
          let variaveisMed = ["numero1", "numero2", "numero3"];
          let valoresMed = ["valor"];
          let simbolosMed = ["+"];
          variaveisMed = variaveisMed.sort(() => Math.random() * 2 - 1);
          valoresMed = valoresMed.sort(() => Math.random() * 2 - 1);
          listaCondicionais = listaCondicionais.sort(
            () => Math.random() * 2 - 1
          );
          montagem.push(
            `${variaveisMed[0]} ${listaCondicionais[0]} ${variaveisMed[1]}`
          );
          montagem.push(
            `${variaveisMed[0]} ${simbolosMed[0]} ${variaveisMed[1]} ${simbolosMed[0]} ${variaveisMed[2]}`
          );
          montagem.push(`${valoresMed[0]}`);
          return montagem;
        default:
          let variaveisDif = ["numero1", "numero2", "numero3"];
          let valoresDif = ["valor"];
          let simbolosDif = ["+", "*"];
          variaveisDif = variaveisDif.sort(() => Math.random() * 2 - 1);
          valoresDif = valoresDif.sort(() => Math.random() * 2 - 1);
          listaCondicionais = listaCondicionais.sort(
            () => Math.random() * 2 - 1
          );
          simbolosDif = simbolosDif.sort(() => Math.random() * 2 - 1);
          montagem.push(
            `${variaveisDif[0]} ${listaCondicionais[0]} ${variaveisDif[1]}`
          );
          montagem.push(
            `${variaveisDif[0]} ${simbolosDif[0]} ${variaveisDif[1]} ${simbolosDif[1]} ${variaveisDif[2]}`
          );
          montagem.push(`${valoresDif[0]}`);
          return montagem;
      }
  }
}
